import { API } from '../../../common/api/constants';

// ПОЛУЧЕНИЕ ИНФОРМАЦИИ О ПРОФИЛЕ
export const API_PROFILE_INFO = `${API}/authorization/profile/`;

// ПОЛУЧИТЬ ВСЕ ФИЛЬТРЫ
export const GET_ALL_FILTERS = `${API}/setting/filter/filters`;

// ПОЛУЧИТЬ ВСЕ ВЫБРАННЫЕ ФИЛЬТРЫ ДЛЯ ПРОФИЛЯ
export const GET_PROFILE_FILTERS = `${API}/setting/profile/filters/{profile_id}`;

// ОБНОВИТЬ ВЫБРАННЫЕ ФИЛЬТРЫ ДЛЯ ПРОФИЛЯ
export const UPDATE_PROFILE_FILTERS = `${API}/setting/profile/filters`;

// ОБНОВИТЬ ФОТОГРАФИЮ ПРОФИЛЯ
export const UPLOAD_PROFILE_PHOTO = `${API}/utility/image/upload/user`; // todo сделать проверку по профилю

// УДАЛИТЬ ФОТОГРАФИЮ ПРОФИЛЯ
export const DELETE_PROFILE_PHOTO = `${API}/utility/image/delete/user`;

// ОБНОВИТЬ ФОТОГРАФИЮ КОМПАНИИ
export const UPLOAD_COMPANY_PHOTO = `${API}/utility/image/upload/company`;

// УДАЛИТЬ ФОТОГРАФИЮ КОМПАНИИ
export const DELETE_COMPANY_PHOTO = `${API}/utility/image/delete/company`;

// ДАННЫЕ ПО КОМПАНИИ
export const GET_COMPANY_INFO = `${API}/authorization/company/{company_id}`;

